import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionService {
  async isSameVersion(): Promise<boolean> {
    return await this.#getVersionNumber() === environment.appVersion;
  }

  #getVersionNumber(): Promise<string> {
    return fetch('assets/version.txt')
      .then(response => response.text());
  }
}
